import { TourConfig } from '../models/tour-config.model';
import { TourFeature } from '../config/tour-feature.enum';
import { Audience } from '../config/audience.enum';
import { TourTrigger } from '../config/trigger.enum';
import { AnchorId } from '../config/anchor.registry';

/**
 * Kontextuelle In-Dialog-Tour fuer "Terminal hinzufuegen". 2 Steps: Name,
 * Passwort. Wird via Hilfe-Button im Dialog manuell gestartet.
 */
const AUTO_ADVANCE_ON_BLUR = {
  enabled: true,
  triggerOn: 'blur' as const,
  debounceMs: 300,
  minLength: 1,
};

export const TERMINAL_ADD_CONTEXTUAL_TOUR: TourConfig = {
  id: TourFeature.TerminalAddContextual,
  version: 2,
  title: 'ADD_TERMINAL',
  description: 'TERMINAL_CONTEXTUAL_TOUR_DESC',
  audience: [Audience.Admin, Audience.TeamLeader],
  triggers: [TourTrigger.Manual],
  statePolicy: {
    allowReplay: true,
    snoozeEnabled: false,
    cooldownHoursAfterDismiss: 0,
    cooldownHoursAfterSnooze: 0,
    suppressAfterCompletion: false,
  },
  priority: 10,
  estimatedDurationSec: 40,
  category: 'contextual-help',
  chapters: [
    {
      id: 'basics',
      title: 'BASIC',
      steps: [
        {
          id: 'name',
          anchor: AnchorId.TerminalNameField,
          title: 'TERMINAL_NAME_FIELD_TITLE',
          content: 'EXPLANATION_FOR_TERMINAL_NAME_FIELD',
          placement: 'left',
          dialogContext: { attachToDialog: true },
          nextCondition: 'onInput',
          autoAdvance: AUTO_ADVANCE_ON_BLUR,
        },
        {
          id: 'password',
          anchor: AnchorId.TerminalPasswordField,
          title: 'TERMINAL_PASSWORD_FIELD_TITLE',
          content: 'EXPLANATION_FOR_TERMINAL_PASSWORD_FIELD',
          placement: 'left',
          dialogContext: { attachToDialog: true },
          nextCondition: 'onInput',
          autoAdvance: AUTO_ADVANCE_ON_BLUR,
        },
      ],
    },
  ],
};
